import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-blue-50 to-green-50 border-t-2 border-gray-200 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo & Copyright */}
          <div className="text-center md:text-left">
            <div className="text-2xl font-bold tracking-tight flex items-center gap-1 mb-2">
              <span className="text-blue-500">P</span>
              <span className="text-red-500">a</span>
              <span className="text-yellow-500">v</span>
              <span className="text-blue-500">a</span>
              <span className="text-green-500">n</span>
              <span className="text-gray-700">.</span>
            </div>
            <p className="text-gray-600 text-sm">
              © {currentYear} {personalInfo.name}. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href={`mailto:${personalInfo.email}`}
              className="p-3 bg-white hover:bg-red-50 border-2 border-gray-200 hover:border-red-300 rounded-lg transition-all duration-300 group"
              aria-label="Email"
            >
              <Mail className="text-gray-600 group-hover:text-red-500 transition-colors" size={20} />
            </a>
            <a
              href={`https://${personalInfo.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-white hover:bg-blue-50 border-2 border-gray-200 hover:border-blue-300 rounded-lg transition-all duration-300 group"
              aria-label="LinkedIn"
            >
              <Linkedin className="text-gray-600 group-hover:text-blue-500 transition-colors" size={20} />
            </a>
          </div>
        </div>

        
        {/* <div className="mt-8 pt-8 border-t-2 border-gray-200 text-center">
          <p className="text-gray-600 text-sm">
            Built with <span className="text-red-500">♥</span> using React • Designed for DevOps Excellence
          </p>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;